module.exports = __webpack_public_path__ + "img/8.51a1ec4a.png";